import helpers from '@/router/helpers';
import UserRoles from '@/constants/user/roles';

export default {
    path: '/inventory/shelve',
    meta: {
        title: 'Shelve',
        documentTitle: 'Inventory Shelve',
        requiresAuth: true,
        mdiIcon: '',
        shouldPersistBetweenLogins: true,
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.INVENTORY_OPERATOR,
            UserRoles.INVENTORY_ADMINISTRATOR,
        ],
    },
    component: helpers.getRouterView(),
    children: [
        {
            path: '',
            name: 'InventoryShelve',
            meta: {
                title: 'Shelve',
                documentTitle: 'Inventory Shelve',
                allowedRoles: [
                    UserRoles.SUPER_ADMIN,
                    UserRoles.INVENTORY_OPERATOR,
                    UserRoles.INVENTORY_ADMINISTRATOR,
                ],
            },
            component: () => import( /* webpackChunkName: "InventoryShelve" */ '@/views/inventory/Shelve' ),
        },
    ],
};
